export default "__VITE_ASSET__baa133fd__"